import { gql } from '@apollo/client';

export default gql`
  mutation editPlace(
    $id: ID!
    $name: String!
    $street: String!
    $city: String!
    $zipCode: String!
    $phone: String
    $email: String
    $contactPerson: String
    $notes: String
  ) {
    editPlace(
      input: {
        id: $id
        name: $name
        street: $street
        city: $city
        zipCode: $zipCode
        phone: $phone
        email: $email
        contactPerson: $contactPerson
        notes: $notes
      }
    ) {
      place {
        id
      }
    }
  }
`;
